import { Layout, LayoutAxis, PlotData } from "plotly.js";

import { PlotParams } from "react-plotly.js";
import { WindowSize } from "Utils/screenSizeUtils";

export interface DefaultLayout {
  height?: number;
  width?: number;
  marginR?: number;
}

export const getPlotConfig = (): PlotParams["config"] => ({
  responsive: true,
  staticPlot: true,
});

export const getPlotLayout = (
  additionalYaxisSettings: Partial<LayoutAxis>,
  windowSize: WindowSize,
  defaultLayout?: DefaultLayout,
): Partial<Layout> => {
  let width = defaultLayout?.width ?? 420;
  if (windowSize.width) {
    if (windowSize.width < 440) {
      width = 220;
    } else if (windowSize.width < 540) {
      width = 320;
    }
  }
  return {
    barmode: "stack",
    height: defaultLayout?.height ?? 250,
    width,
    margin: { t: 20, l: 0, r: defaultLayout?.marginR ?? 100 },
    yaxis: {
      nticks: 3,
      side: "right",
      ...additionalYaxisSettings,
    },
    transition: {
      duration: 200,
      easing: "linear",
    },
  };
};

export const getDefaultPlotData = (): Partial<PlotData> => ({
  type: "bar",
  cliponaxis: false,
  showlegend: true,
  textposition: "outside",
  width: [0.6, 0.6, 0.6],
});

export const getLegendConfig = (y = -0.5): Partial<Layout> => ({
  legend: { x: 0.0, y },
});
